module.exports = __webpack_public_path__ + "static/media/IB_logo.36ec4360.jpg";